// §4.4 partial — admin/system routes.
// Composer auto-collects this into routes.generated.ts.
//
// 07/08/2026: /admin/system/{history,alerts,stats} foram REMOVIDAS. As três
// telas só sabiam dizer "Feature not yet implemented — backend endpoint
// missing" porque /api/v2/admin/system/{history,alerts,stats} nunca existiu
// no backend (nenhum router com esse prefixo, nada no openapi.yaml). Rota que
// só promete e frustra é pior que rota inexistente — agora dão 404 honesto.
// Sobra o que tem endpoint de verdade: SystemPage lê /api/v2/health/*.
import { lazyWithRetry } from "@/lib/lazy/lazyWithRetry";
import type { RouteObject } from "react-router-dom";
import { AdminLayout } from "../_layout/AdminLayout";

const SystemPage = lazyWithRetry(() => import("./pages/SystemPage"));

const routes: RouteObject[] = [
  {
    Component: AdminLayout,
    children: [
      { path: "/admin/system", Component: SystemPage },
      { path: "/admin/system/status", Component: SystemPage },
    ],
  },
];

export default routes;
